"use client";

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ArrowDown2 } from "iconsax-reactjs";
import { useTranslations } from "next-intl";
import * as React from "react";

import { cn } from "@/lib/utils";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.CollapsibleTrigger>,
  React.ComponentPropsWithoutRef<
    typeof CollapsiblePrimitive.CollapsibleTrigger
  > & {
    openedText?: string;
    closedText?: string;
  }
>(({ className, openedText, closedText, children, ...props }, ref) => {
  const t = useTranslations("common.form");
  const resolvedOpenedText = openedText ?? t("collapseOpen");
  const resolvedClosedText = closedText ?? t("collapseClosed");
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      ref={ref}
      className={cn(
        "group flex items-center justify-between w-full gap-2 transition-all",
        "data-[state=open]:[&_svg]:rotate-180",
        className,
      )}
      {...props}
    >
      {children}
      <div className="flex items-center gap-2">
        <span className="group-data-[state=open]:hidden">
          {resolvedClosedText}
        </span>
        <span className="hidden group-data-[state=open]:inline">
          {resolvedOpenedText}
        </span>
        <ArrowDown2 className="size-4 transition-transform duration-200" />
      </div>
    </CollapsiblePrimitive.CollapsibleTrigger>
  );
});
CollapsibleTrigger.displayName =
  CollapsiblePrimitive.CollapsibleTrigger.displayName;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
